import React from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { Paper, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { formatCurrency } from "../../hooks/Currency";

const MonthlySalesChart = ({ sellsPerMonth }) => {
  const { t } = useTranslation();

  // Get selected store from Redux
  const _store = useSelector((state) => state.pos.defStore);

  const options = {
    chart: {
      height: 350,
      type: "area",
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => formatCurrency(val, _store),
    },
    stroke: {
      curve: "smooth",
    },
    xaxis: {
      categories: [
        t("jan"),
        t("feb"),
        t("mar"),
        t("apr"),
        t("may"),
        t("jun"),
        t("jul"),
        t("aug"),
        t("sep"),
        t("oct"),
        t("nov"),
        t("dec"),
      ],
    },
    yaxis: {
      title: {
        text: t("totalSales"),
        style: {
          color: "var(--gray-color)",
          fontFamily: "roboto",
        },
      },
      labels: {
        formatter: (val) => formatCurrency(val, _store),
        style: {
          fontSize: "14px",
        },
      },
    },
    colors: ["#00E396"],
    tooltip: {
      y: {
        formatter: (val) => formatCurrency(val, _store),
      },
    },
  };

  const series = [
    {
      name: t("sales"),
      data: sellsPerMonth,
    },
  ];

  return (
    <Paper className="shadow-xs p-15 br-6">
      <Typography variant="h6" className="fs-18 fw-5 gray-color mb-10">
        {t("monthlySalesReports")}
      </Typography>

      <ReactApexChart
        options={options}
        series={series}
        type="area"
        width="100%"
        height="220"
      />
    </Paper>
  );
};

export default MonthlySalesChart;